import { render, staticRenderFns } from "./livebofangxbk.vue?vue&type=template&id=4131b530&scoped=true"
import script from "./livebofangxbk.vue?vue&type=script&lang=js"
export * from "./livebofangxbk.vue?vue&type=script&lang=js"
import style0 from "./livebofangxbk.vue?vue&type=style&index=0&id=4131b530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131b530",
  null
  
)

export default component.exports